import { render, staticRenderFns } from "./StaffNotification.vue?vue&type=template&id=d422da6e&"
import script from "./StaffNotification.vue?vue&type=script&lang=ts&"
export * from "./StaffNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports